import { render, staticRenderFns } from "./SaleTypeEditName.vue?vue&type=template&id=0f43417a&scoped=true"
import script from "./SaleTypeEditName.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43417a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f43417a')) {
      api.createRecord('0f43417a', component.options)
    } else {
      api.reload('0f43417a', component.options)
    }
    module.hot.accept("./SaleTypeEditName.vue?vue&type=template&id=0f43417a&scoped=true", function () {
      api.rerender('0f43417a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeEditName.vue"
export default component.exports